module.exports = __webpack_public_path__ + "static/media/pulmonologyImage2@3x.a822a9b3.png";